import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-word-plugin-lite',
  templateUrl: './word-plugin-lite.component.html',
  styleUrls: ['./word-plugin-lite.component.scss']
})
export class WordPluginLiteComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService
  ) { }
  ngOnInit() {
    this.titleService.setTitle("免費文法檢查外掛程式（輕量版）適用於 Microsoft Word ");
    this.metaTagService.updateTag({ name: 'description', content: "在 Windows、Mac 和 Office 365 上使用 Trinka 的 Word 外掛程式，即時進行高級文法檢查，讓你在撰寫時也能維持高品質的文字表現。" });
    this.metaTagService.updateTag({ property: 'og:title', content: "免費文法檢查外掛程式（輕量版）適用於 Microsoft Word " });
    this.metaTagService.updateTag({ property: 'og:description', content: "在 Windows、Mac 和 Office 365 上使用 Trinka 的 Word 外掛程式，即時進行高級文法檢查，讓你在撰寫時也能維持高品質的文字表現。" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/wordplugin-lite' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/maclite-banner.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '免費文法檢查外掛程式（輕量版）適用於 Microsoft Word ' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "在 Windows、Mac 和 Office 365 上使用 Trinka 的 Word 外掛程式，即時進行高級文法檢查，讓你在撰寫時也能維持高品質的文字表現。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/maclite-banner.svg' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'office 365 grammar check, word 365 grammar check, microsoft 365 grammar check, outlook 365 grammar check, grammar check office 365, grammar check in office 365' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/wordplugin-lite' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/wordplugin-lite' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/wordplugin-lite' });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

}
